/*
 * @Descripttion:
 * @Author: Jun Chen
 * @Date: 2021-1-22 23:07:49
 */
export default [
  {
    path: '/sealBookManage',
    name: 'sealBookManage',
    hidden: false,
    meta: {
      title: '印章数据管理',
      icon: '',
      nav: 'act',
      level: 1
    },
    component: resolve => require(['@/views/Application.vue'], resolve),
    children: [
      {
        path: '/sealBookManageIndex',
        name: 'sealBookManageIndex',
        hidden: false,
        meta: {
          title: '印章数据管理',
          level: 1,
          nav: 'act',
          icon: ''
        },
        component: resolve => require(['@/views/seal-book-manage/manage'], resolve)
      },
      {
        path: '/addSealBook',
        name: 'addSealBook',
        hidden: true,
        meta: {
          title: '添加印章',
          level: 1,
          nav: 'act',
          icon: ''
        },
        component: resolve => require(['@/views/seal-book-manage/add'], resolve)
      },
      {
        path: '/sealBookManageProgress',
        name: 'sealBookManageProgress',
        hidden: true,
        meta: {
          title: '进度设置',
          level: 1,
          nav: 'act',
          icon: ''
        },
        component: resolve => require(['@/views/seal-book-manage/book-progress'], resolve)
      },
      {
        path: '/sealBookPrintInter',
        name: 'sealBookPrintInter',
        hidden: true,
        meta: {
          title: '印章说明设置',
          level: 1,
          nav: 'act',
          icon: ''
        },
        component: resolve => require(['@/views/seal-book-manage/book-print-inter'], resolve)
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/router-seal-book.js